(function () {
setTimeout(function () {
    const countdownSection = document.querySelector(".container_countdown");
    const closeBtn = document.getElementById("meze-countdown-close");

    if (!countdownSection) return;

    if (!sessionStorage.getItem("meze-countdown-close")) {
        countdownSection.style.display = "flex";

        if (closeBtn) {
            closeBtn.addEventListener("click", function () {
                countdownSection.style.display = "none";
                sessionStorage.setItem("meze-countdown-close", "true");
            });
        }
    } else {
        countdownSection.style.display = "none";
    }
}, 300);

// Set the target date and time (in Bucharest time)
var targetDate = new Date("Nov 23, 2026 14:00:00").getTime();

// Update the countdown every second
var countdownInterval = setInterval(function() {

    // Get the current date and time in Bucharest
    var bucharestDatetimeStr = new Date().toLocaleString("en-US", { timeZone: "Europe/Bucharest" });
    var dateBucharest = new Date(bucharestDatetimeStr);
    var now = dateBucharest.getTime();

    // Calculate the remaining time
    var distance = targetDate - now;

    // Pencil Banner IDs
    const days = document.getElementById("days_banner");
    const hours = document.getElementById("hours_banner");
    const minutes = document.getElementById("minutes_banner");
    const seconds = document.getElementById("seconds_banner");
    const textBlockCountdown = document.getElementById("countdown");

    // Section IDs (LP)
    const daysLP = document.getElementById("days_banner_lp");
    const hoursLP = document.getElementById("hours_banner_lp");
    const minutesLP = document.getElementById("minutes_banner_lp");
    const secondsLP = document.getElementById("seconds_banner_lp");
    const textBlockCountdownLP = document.getElementById("countdown_lp");

    // Display values function
    function update(daysUpdate, hoursUpdate, minutesUpdate, secondsUpdate) {
        if (!daysUpdate || !hoursUpdate || !minutesUpdate || !secondsUpdate) return;
        daysUpdate.innerText = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0');
        hoursUpdate.innerText = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
        minutesUpdate.innerText = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
        secondsUpdate.innerText = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0');
    }

    // Apply to both banners if they exist
    update(days, hours, minutes, seconds);
    update(daysLP, hoursLP, minutesLP, secondsLP);

    // If the countdown is finished, display a message
        if (distance < 0) {
        clearInterval(countdownInterval);
        if(textBlockCountdown) {
            textBlockCountdown.innerHTML = "Black Friday 23.11 - 01.12";
            textBlockCountdown.classList.add("pencil-banner-countdown");
        }

        if(textBlockCountdownLP) {
            textBlockCountdownLP.innerHTML = "23.11 - 01.12";
        }
    }
}, 1000);
  
})();